"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameManager = void 0;
var AppCore_1 = require("../AppCore");
var GameManager = /** @class */ (function () {
    function GameManager(_levelManager, _scoreManager) {
        this._levelManager = _levelManager;
        this._scoreManager = _scoreManager;
    }
    GameManager.prototype.start = function () {
        this._levelManager.startLevel();
    };
    GameManager.prototype.restart = function () {
        this._levelManager.restartLevel();
    };
    GameManager.prototype.end = function () {
        this._levelManager.completeLevel();
    };
    GameManager.prototype.checkAndScoreAnswer = function (answer) {
        var correct = this._levelManager.checkAnswer(answer);
        if (correct === true) {
            this._scoreManager.incrementScore();
        }
        else {
            this._scoreManager.decrementScore();
        }
        return correct;
    };
    GameManager.prototype.hasCompletedLevel = function () {
        return this._levelManager.hasCompletedLevel();
    };
    GameManager.prototype.getCurrentWord = function () {
        var id = this._levelManager.currentLevel.quiz.currentWord;
        var word = AppCore_1.AppCore.instance.getWordById(id);
        if (word == null) {
            return "XXX";
        }
        return word.text;
    };
    GameManager.prototype.getCurrentLevel = function () {
        return this._levelManager.currentLevel;
    };
    GameManager.prototype.getScoreData = function () {
        return this._scoreManager.getScoreData();
    };
    GameManager.prototype.getCurrentScore = function () {
        return this._scoreManager.getCurrentScore();
    };
    return GameManager;
}());
exports.GameManager = GameManager;
